// Single source of truth for site copy.
// Home and Services previously duplicated these lists verbatim.

export const company = {
  name: 'Aldaron Limited',
  short: 'Aldaron',
  tagline: 'Innovate. Empower. Deliver.',
  location: 'Sarcom Centre, Kitengela, Nairobi-Namanga Road',
  summary:
    'Aldaron Limited delivers ICT infrastructure and enterprise technology as one engineered ecosystem — solving problems from consulting and software through hardware and IoT, and putting the finished product in users’ hands with simplicity.',
  about: [
    'Aldaron Limited is a Kenyan-registered company delivering integrated information and communication technology (ICT) and creative solutions to businesses, institutions, and government agencies. We combine technical expertise with creative insight to help our clients modernize their operations, strengthen their brand identity, and compete effectively in a fast-changing digital economy.',
    "As a growing player in Kenya's ICT and creative services sector, Aldaron Limited is committed to innovation, reliability, and measurable value for every client we serve.",
  ],
  phones: ['+254 706 861 509', '+254 702 588 126'],
  emails: ['info@aldaronltd.com', 'Aldaronltd@gmail.com'],
}

export const vision =
  'To be a leading provider of information and communication technology and creative solutions in Kenya and the wider East Africa region, recognized for innovation, quality, and integrity.'

export const mission =
  'To design, develop, and deliver reliable technology, branding, and creative solutions tailored to the evolving needs of our clients — enhancing efficiency, visibility, and competitiveness through professional service and technical expertise.'

export const services = [
  {
    slug: 'ict-systems',
    short: 'ICT Systems & Software',
    icon: 'code',
    title: 'ICT Systems, Software & Web Development',
    blurb:
      'Design and development of custom information systems and business software.',
  },
  {
    slug: 'electrical-supply',
    short: 'Electrical Appliances',
    icon: 'bolt',
    title: 'Electrical Appliances Supply',
    blurb:
      'Supply of electrical appliances through competitive tenders and direct procurement.',
  },
  {
    slug: 'photography',
    short: 'Photography & Video',
    icon: 'camera',
    title: 'Photography & Videography',
    blurb:
      'Corporate, event, and product photography for businesses and institutions, plus corporate and event videography including coverage and editing.',
  },
  {
    slug: 'it-support',
    short: 'IT Support',
    icon: 'support',
    title: 'IT Support & Technical Services',
    blurb:
      'Technology advisory for businesses and institutions — systems planning, digital transformation, and procurement guidance.',
  },
  {
    slug: 'branding',
    short: 'Branding & Identity',
    icon: 'palette',
    title: 'Branding & Corporate Identity',
    blurb:
      'Logo design and complete corporate identity packages, marketing collateral, signage, and brand guideline development.',
  },
  {
    slug: 'ict-equipment',
    short: 'ICT Equipment Supply',
    icon: 'devices',
    title: 'Computer, Mobile & ICT Equipment',
    blurb:
      'Computers, mobile phones, phone accessories, printers, networking equipment, and other related ICT hardware.',
  },
  {
    slug: 'ict-consultancy',
    short: 'ICT Consultancy',
    icon: 'compass',
    title: 'ICT Consultancy',
    blurb: 'Technology advisory, systems planning, digital transformation, and procurement guidance.',
  },
  {
    slug: 'cybersecurity',
    short: 'Cybersecurity',
    icon: 'shield',
    title: 'Cybersecurity Services',
    blurb: 'Practical security testing, monitoring, cloud security, and compliance support.',
  },
]

export const serviceDetails = {
  'ict-systems': ['Custom information systems & business software', 'Website development, hosting & domain management', 'Genuine software licensing & Windows configuration', 'POS, HR, payroll, Sacco, HMIS/LMS & management systems', 'SEO optimisation, bulk messaging & WhatsApp API integration'],
  'electrical-supply': ['Electrical appliance supply through direct procurement or competitive tender', 'Installation and after-sales support for supplied equipment'],
  photography: ['Corporate, event & product photography', 'Corporate and event videography', 'Coverage, editing & delivery-ready media'],
  'it-support': ['Computer and laptop repair', 'System and software auditing', 'Data recovery and data cloning', 'Technical support and troubleshooting'],
  branding: ['Logo design & corporate identity packages', 'Marketing collateral, signage & brand guidelines', 'Print, merchandise, vehicle & social media branding'],
  'ict-equipment': ['Laptops, desktops, printers & networking equipment', 'Mobile phones and computer or phone accessories', 'Genuine ICT hardware, cartridges and toners'],
  'ict-consultancy': ['Technology advisory for businesses and institutions', 'Systems planning and digital transformation', 'Procurement guidance and solution scoping'],
  cybersecurity: ['Ethical hacking & penetration testing', 'Threat monitoring', 'Cloud computing & security', 'Cyber law & compliance'],
}

// Titles were rewritten to match the descriptions the company already wrote
// (the previous headings — e.g. "Software Development" over a licensing blurb — did not).
export const differentiators = [
  {
    icon: 'layers',
    title: 'One partner, end to end',
    blurb:
      'Combined ICT and creative expertise under one roof — systems, software, hardware, branding, and photography.',
  },
  {
    icon: 'document',
    title: 'Tender & procurement ready',
    blurb:
      'Proven experience in competitive tender and direct procurement supply.',
  },
  {
    icon: 'shield',
    title: 'Genuine, quality-assured supply',
    blurb: 'Genuine software licensing and quality-assured hardware.',
  },
  {
    icon: 'compass',
    title: 'Practical consultancy',
    blurb:
      'Client-focused consultancy grounded in practical, real-world technology needs.',
  },
  {
    icon: 'support',
    title: 'Support that answers',
    blurb:
      'Responsive, professional service from initial consultation through delivery and after-sales support.',
  },
]

export const stats = [
  { value: '230+', label: 'Projects delivered' },
  { value: '110+', label: 'Satisfied clients' },
  { value: '2+', label: 'Years of innovation' },
  { value: '20+', label: 'Professional services' },
]

export const sectors = [
  'Business & enterprise',
  'Government & institutions',
  'Construction & property',
  'Agriculture',
  'Retail & logistics',
  'Travel & education',
]

export const partners = [
  {
    name: 'GlobalQuest Logistics Investments Ltd',
    image: '/client-logos/globalquest-logistics.jpg',
    description: 'General supplies and logistics consultants',
  },
  {
    name: 'Wakilisha Hub',
    image: '/client-logos/wakilisha-hub.png',
    description: 'Enabling justice',
  },
]

export const clients = [
  { name: 'Dorah Investments Ltd', image: '/client-logos/dorah-investments.jpg' },
  { name: 'Intercore Builders', image: '/client-logos/intercore-builders.jpg' },
  { name: 'Lucygaceri Investments', image: '/client-logos/lucygaceri-investments.jpg' },
  { name: 'MMG Autofixx Kenya', image: '/client-logos/mmg-autofixx.jpg' },
  { name: 'On-Plan Construction and Repair Works', image: '/client-logos/onplan-construction.jpg' },
  { name: 'Puresure Movers & Cleaners', image: '/client-logos/puresure-movers.jpg' },
  { name: 'Shoeniverse Kenya', image: '/client-logos/shoeniverse-kenya.jpg' },
  { name: 'Thinga Travel', image: '/client-logos/thinga-travel.jpg' },
  { name: 'Trendy Stocks Limited', image: '/client-logos/trendy-stocks.jpg' },
]

export const products = [
  {
    name: 'DwellKwetu',
    category: 'Property management system',
    slug: 'dwellkwetu',
    accent: '#D9A441',
    icon: 'devices',
    headline: 'Every property, tenant and shilling accounted for.',
    description: 'Manage properties, tenants, payments and maintenance seamlessly.',
    sub: 'DwellKwetu gives landlords, agencies and facility managers one place to handle leases, collections, maintenance and reporting across an entire portfolio.',
    highlights: ['Automated rent invoicing and M-Pesa reconciliation', 'Tenant self-service portal for statements and requests', 'Portfolio-wide occupancy and arrears visibility'],
    features: [
      { title: 'Portfolio & Units', body: 'Model buildings, units, meters and shared facilities with the exact structure your portfolio uses.' },
      { title: 'Leases & Tenants', body: 'Digital lease records, renewals, deposits, escalations and notice tracking with reminders.' },
      { title: 'Rent Collection', body: 'Invoices issued on schedule, with payments auto-matched from mobile money and bank feeds.' },
      { title: 'Maintenance', body: 'Tenants log issues, you assign vendors, and every job carries cost and completion evidence.' },
      { title: 'Utilities & Levies', body: 'Water, power, service charge and parking are billed accurately per unit, every cycle.' },
      { title: 'Owner Reporting', body: 'Statements, arrears ageing and yield reporting landlords can understand without a call.' },
    ],
    modules: ['Properties', 'Units', 'Leases', 'Tenants', 'Invoicing', 'Receipting', 'Arrears', 'Maintenance', 'Vendors', 'Utilities', 'Documents', 'Reports'],
    metrics: [{ value: '94%', label: 'On-time collection rate' }, { value: '8 hrs', label: 'Saved per week on reconciliation' }, { value: '100%', label: 'Digital lease coverage' }],
    image: '/dwellkwetu-logo.png',
    href: 'https://dwellkwetu.com',
  },
  {
    name: 'FluxHMS', slug: 'fluxhms', category: 'Hospital Management System', accent: '#60D5B1', icon: 'support', headline: 'Run the whole hospital from one system.',
    description: 'Smart, integrated and compliant healthcare management.',
    sub: 'FluxHMS unifies patient records, clinical workflows, pharmacy, laboratory, billing and insurance claims into a single compliant platform built for African health facilities.',
    highlights: ['Electronic medical records with a complete patient timeline', 'NHIF and private insurer claims processed without re-keying', 'Works on low bandwidth and keeps running when the line drops'],
    features: [
      { title: 'Electronic Medical Records', body: 'One longitudinal record per patient across every department, visit and facility in your network.' },
      { title: 'Clinical Workflows', body: 'Triage, consultation, admission, theatre and discharge flows that match how clinicians actually work.' },
      { title: 'Pharmacy & Inventory', body: 'Live stock positions, expiry tracking, reorder levels and dispensing tied straight to prescriptions.' },
      { title: 'Laboratory & Radiology', body: 'Order sets, sample tracking and results delivered back into the patient record automatically.' },
      { title: 'Billing & Insurance', body: 'Cash, corporate and insurance billing with claim preparation, submission and reconciliation built in.' },
      { title: 'Compliance & Audit', body: "Role-based access, full audit trails and data-protection controls aligned to Kenya's DPA." },
    ],
    modules: ['Registration', 'Triage', 'Outpatient', 'Inpatient', 'Theatre', 'Pharmacy', 'Laboratory', 'Radiology', 'Billing', 'Claims', 'Stores', 'Reporting'],
    metrics: [{ value: '60%', label: 'Less time on admissions paperwork' }, { value: '3×', label: 'Faster insurance claim turnaround' }, { value: '99.9%', label: 'Platform uptime' }],
  },
  {
    name: 'FluxCommerce', slug: 'fluxcommerce', category: 'Commerce & Delivery Platform', accent: '#FF9F43', icon: 'bolt', headline: 'Sell everywhere. Fulfil from one place.',
    description: 'Unified platform for shops, deliveries, inventory and customer experiences.',
    sub: 'FluxCommerce joins storefront, point of sale, stock and last-mile delivery so a single order flows cleanly from checkout to doorstep.',
    highlights: ['One stock pool across web, POS, WhatsApp and marketplace', 'Dispatch and rider tracking built into fulfilment', 'Customer profiles, loyalty and campaigns in one view'],
    features: [
      { title: 'Storefront', body: 'Fast, mobile-first shopping built for African bandwidth and payment habits.' },
      { title: 'Point of Sale', body: 'Counter, kiosk and field sales sharing the same catalogue and stock as your online store.' },
      { title: 'Inventory', body: 'Multi-branch stock, transfers, batch and expiry control with live availability.' },
      { title: 'Fulfilment & Delivery', body: 'Pick, pack, dispatch and track with your own riders or a partner fleet.' },
      { title: 'Payments', body: 'Mobile money, card, bank and pay-on-delivery settled and reconciled automatically.' },
      { title: 'Customers & Loyalty', body: 'Segments, points, offers and messaging driven by real purchase behaviour.' },
    ],
    modules: ['Catalogue', 'Storefront', 'POS', 'Orders', 'Inventory', 'Branches', 'Dispatch', 'Riders', 'Payments', 'Loyalty', 'Campaigns', 'Analytics'],
    metrics: [{ value: '2.4×', label: 'Repeat purchase rate' }, { value: '31 min', label: 'Median delivery dispatch' }, { value: '0', label: 'Manual stock reconciliations' }],
    href: 'https://fluxcommerce.co.ke',
  },
  {
    name: 'FluxChama', slug: 'fluxchama', category: 'Chama Management Platform', accent: '#B68CFF', icon: 'layers', headline: "Trust your group's books again.",
    description: 'Transparent savings, loans, contributions and group growth.',
    sub: 'FluxChama brings contributions, loans, fines and investments into a shared ledger every member can see — so groups grow on evidence, not memory.',
    highlights: ['Automatic contribution tracking and member statements', 'Loan applications, approvals, schedules and repayments', 'Meeting minutes, votes and audit-ready records'],
    features: [
      { title: 'Members & Roles', body: 'Officials, signatories and members with permissions that match your constitution.' },
      { title: 'Contributions', body: 'Scheduled and ad-hoc contributions collected by mobile money and reconciled instantly.' },
      { title: 'Loans', body: 'Applications, guarantors, approval workflows, interest schedules and repayment tracking.' },
      { title: 'Fines & Welfare', body: 'Rules applied consistently, with balances every member can verify for themselves.' },
      { title: 'Investments', body: 'Track group assets, projects and returns against the targets you set together.' },
      { title: 'Governance', body: 'Meetings, agendas, minutes and resolutions stored with the financial record they relate to.' },
    ],
    modules: ['Members', 'Contributions', 'Loans', 'Guarantors', 'Repayments', 'Fines', 'Welfare', 'Investments', 'Meetings', 'Statements', 'Audit', 'Payouts'],
    metrics: [{ value: '100%', label: 'Member-visible ledger' }, { value: '5 min', label: 'To close a monthly cycle' }, { value: '0', label: 'Disputed balances' }],
  },
  {
    name: 'FluxRide', slug: 'fluxride', category: 'Ride-hailing & Delivery Platform', accent: '#FF6B81', icon: 'compass', headline: 'Move people and parcels on one network.',
    description: 'Reliable rides, fast deliveries and real-time tracking.',
    sub: 'FluxRide is a complete mobility stack — rider and driver apps, dispatch intelligence, pricing, payments and a control room that sees every trip.',
    highlights: ['Dispatch that matches on distance, rating and demand', 'Live tracking, trip sharing and SOS for safety', 'Driver earnings, payouts and fleet compliance built in'],
    features: [
      { title: 'Passenger App', body: 'Book, track, split fares and pay by wallet, mobile money or card.' },
      { title: 'Driver App', body: 'Trip offers, navigation, earnings and documents in a lightweight app for real handsets.' },
      { title: 'Smart Dispatch', body: 'Matching that balances proximity, acceptance history, vehicle class and live demand.' },
      { title: 'Pricing & Zones', body: 'Base fares, surge, corridors and airport rules configured per city without a release.' },
      { title: 'Deliveries', body: 'Parcel and food jobs on the same fleet, with proof of delivery and batching.' },
      { title: 'Control Room', body: 'Live map, incident handling, trip replay and fleet compliance in one console.' },
    ],
    modules: ['Riders', 'Drivers', 'Vehicles', 'Dispatch', 'Trips', 'Pricing', 'Zones', 'Wallets', 'Payouts', 'Deliveries', 'Safety', 'Control Room'],
    metrics: [{ value: '4.2 min', label: 'Average pickup time' }, { value: '96%', label: 'Trip completion rate' }, { value: '24/7', label: 'Live safety monitoring' }],
  },
  {
    name: 'FluxPay', slug: 'fluxpay', category: 'Payments & Wallet Platform', accent: '#57A8FF', icon: 'shield', headline: 'The payment rail under everything we build.',
    description: 'Secure payments, wallets, transfers and financial services.',
    sub: 'FluxPay handles collections, wallets, disbursements and reconciliation across mobile money, banks and cards — with the controls a regulated business needs.',
    highlights: ['One API for M-Pesa, bank, card and wallet movement', 'Ledgered wallets with holds, limits and full traceability', 'Bulk payouts, settlement files and automated reconciliation'],
    features: [
      { title: 'Collections', body: 'Accept mobile money, cards, bank transfers and USSD with instant confirmation.' },
      { title: 'Wallets', body: 'Double-entry ledgered wallets for users, merchants and agents with holds and limits.' },
      { title: 'Disbursements', body: 'Single and bulk payouts to phones and bank accounts with approval workflows.' },
      { title: 'Reconciliation', body: 'Automated matching against provider statements, with exceptions surfaced rather than buried.' },
      { title: 'Risk & Compliance', body: 'KYC tiers, velocity rules, screening and audit trails aligned to CBK expectations.' },
      { title: 'Developer API', body: 'REST APIs, webhooks and SDKs with a sandbox that mirrors production behaviour.' },
    ],
    modules: ['Collections', 'Wallets', 'Transfers', 'Payouts', 'Ledger', 'Reconciliation', 'KYC', 'Risk Rules', 'Refunds', 'Settlements', 'Webhooks', 'Reports'],
    metrics: [{ value: '10M+', label: 'Transactions daily' }, { value: '<400ms', label: 'Median API response' }, { value: '99.99%', label: 'Ledger accuracy' }],
  },
]

export const values = [
  'Innovation',
  'Quality',
  'Professionalism',
  'Continuous Improvement',
  'Integrity & Honesty',
  'Customer Satisfaction',
  'Team Work',
]

export const policies = [
  {
    title: 'Quality Policy',
    body:
      'Aldaron Limited is committed to consistently meeting and exceeding client expectations through continuous improvement of our service delivery, technical standards, and quality management practices.',
  },
  {
    title: 'Anti-Corruption Policy',
    body:
      'Aldaron Limited conducts all business honestly and ethically, in full compliance with anti-corruption and anti-bribery laws. We maintain zero tolerance for bribery or corrupt practices in any of our dealings, tenders, or procurement processes.',
  },
  {
    title: 'Customer Service Policy',
    body:
      'Every client is treated with professionalism, respect, and fairness regardless of the size or nature of their engagement with us. We are committed to clear communication, timely delivery, and dependable after-sales support.',
  },
]

export const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/products', label: 'Products' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact', label: 'Contact' },
]
